<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'ConfirmProspectManufacturerResponseModal',
  components: { DialogCloseButton, PopupModal },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    show() {
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    async _confirm() {
      this.resolvePromise({
        confirmed: true
      })
      this.$refs.popup.close()
    },
    async _reject() {
      this.resolvePromise({
        confirmed: false
      })
      this.$refs.popup.close()
    }
  }
}
</script>

<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="_reject" />

    <h2 class="content-title text-center">
      {{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_RESPONSE.MODAL.TITLE') }}
    </h2>

    <!--Information-->
    <div class="my-8 content-text-information">
      <p>{{ $t('STEP_PROSPECT.SUB_STEP_PROSPECT_RESPONSE.MODAL.MESSAGE') }}</p>
    </div>

    <!--Send button-->
    <v-row>
      <v-col>
        <v-btn
          :disabled="loading"
          :loading="loading"
          class="boom-button dialog-button"
          variant="outlined"
          type="button"
          @click="_confirm"
        >
          {{ $t('COMMON.BUTTON.CONFIRM') }}
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          :disabled="loading"
          :loading="loading"
          class="boom-button-back dialog-button"
          variant="outlined"
          type="button"
          @click="_reject"
        >
          {{ $t('COMMON.BUTTON.CANCEL') }}
        </v-btn>
      </v-col>
    </v-row>
  </popup-modal>
</template>

<style scoped>
.content-title {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content-text-information {
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.dialog-button {
  min-width: 100px;
  width: 100%;
}
</style>
